import "$styles/index.css"
import "$styles/syntax-highlighting.css"

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

// Cookieloze bezoekersstatistieken
import "./analytics.js"

// Navbar transparant boven hero (alleen op homepage)
const nav = document.getElementById('main-nav')
const isHomepage = document.body.classList.contains('home')

function updateNav() {
  if (isHomepage && window.scrollY < 60) {
    nav.classList.add('nav-transparant')
  } else {
    nav.classList.remove('nav-transparant')
  }
}

if (nav) {
  updateNav()
  window.addEventListener('scroll', updateNav, { passive: true })
}

// Mobile menu toggle
const toggle = document.getElementById('navbar-toggle')
const mobileMenu = document.getElementById('navbar-mobile')

if (toggle && mobileMenu) {
  toggle.addEventListener('click', () => {
    const isOpen = mobileMenu.classList.toggle('hidden')
    mobileMenu.classList.toggle('flex', !isOpen)
    toggle.setAttribute('aria-expanded', String(!isOpen))
    toggle.setAttribute('aria-label', isOpen ? 'Menu openen' : 'Menu sluiten')
  })

  mobileMenu.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', () => {
      mobileMenu.classList.add('hidden')
      mobileMenu.classList.remove('flex')
      toggle.setAttribute('aria-expanded', 'false')
      toggle.setAttribute('aria-label', 'Menu openen')
    })
  })
}

// ============================================================
// FORMULIEREN
// ============================================================
const params = new URLSearchParams(window.location.search)

// Partner-slug uit ?partner=… vullen in alle formulieren op de pagina
const partner = params.get('partner')
if (partner) {
  document.querySelectorAll('[data-partner-field]').forEach(el => {
    el.value = partner
  })
}

// Pakket pre-selecteren bij aankomst via /onderhoud-aanvragen/?pakket=easy
const pakket = params.get('pakket')
if (pakket) {
  const pkgRadio = document.getElementById(`form-pkg-${pakket}`)
  if (pkgRadio) {
    pkgRadio.checked = true
    pkgRadio.dispatchEvent(new Event('change', { bubbles: true }))
  }
}

// Product pre-selecteren bij aankomst via /offerte-aanvragen/?product=cv-ketel
// Matcht de radio op geslugificeerde waarde ("CV-ketel" → "cv-ketel").
const product = params.get('product')
if (product) {
  const wanted = product.toLowerCase()
  document.querySelectorAll('input[name="payload[product]"]').forEach(radio => {
    if (radio.value.toLowerCase().replace(/\s+/g, '-') === wanted) {
      radio.checked = true
      radio.dispatchEvent(new Event('change', { bubbles: true }))
    }
  })
}

// ============================================================
// FORMULIER-VALIDATIE
// ============================================================
function fieldNameFromInput(input) {
  // Field-namen volgen het patroon contact[xyz] of payload[xyz] — pak xyz.
  const m = (input.name || '').match(/[a-z_]+\[(.+?)\]/)
  return m ? m[1] : ''
}

function errorMessageFor(input) {
  const v = input.validity
  const name = fieldNameFromInput(input)
  const type = input.type

  if (!v.valid) {
    if (v.valueMissing) {
      if (type === 'email') return 'Vul uw e-mailadres in'
      if (type === 'tel')   return 'Vul uw telefoonnummer in'
      if (type === 'radio') return 'Maak een keuze'
      switch (name) {
        case 'name':    return 'Vul uw naam in'
        case 'street':  return 'Vul uw straat in'
        case 'number':  return 'Vul uw huisnummer in'
        case 'zipcode': return 'Vul uw postcode in'
        case 'city':    return 'Vul uw plaats in'
      }
      return 'Dit veld is verplicht'
    }
    if (v.typeMismatch && type === 'email') {
      return 'Vul een geldig e-mailadres in (bijv. naam@voorbeeld.nl)'
    }
    if (v.patternMismatch && name === 'zipcode') {
      return 'Vul een geldige postcode in (bijv. 1234 AB)'
    }
    return 'Vul een geldige waarde in'
  }

  // Custom: postcode-prefix moet binnen het werkgebied van Hové vallen.
  // Lijst en foutmelding komen uit het YAML-schema via data-attributen.
  if (input.dataset.allowedAreas && input.value) {
    const prefixMatch = input.value.match(/^\s*([0-9]{2})/)
    if (prefixMatch) {
      const allowed = input.dataset.allowedAreas.split(',')
      if (!allowed.includes(prefixMatch[1])) {
        return input.dataset.areaError || 'Buiten ons werkgebied'
      }
    }
  }

  return null
}

function errorSlotFor(input, form) {
  const name = fieldNameFromInput(input)
  if (input.type === 'radio' || input.closest('[data-field-name]')) {
    const container = input.closest('[data-field-name]') || form.querySelector(`[data-field-name="${CSS.escape(name)}"]`)
    return container ? container.querySelector(':scope > .hove-error') : null
  }
  return document.getElementById(`${input.id}-error`)
}

function showFieldError(input, message, form) {
  const slot = errorSlotFor(input, form)
  if (slot) {
    slot.textContent = message
    slot.removeAttribute('hidden')
  }
  if (input.type === 'radio') {
    const container = input.closest('[data-field-name]')
    container?.setAttribute('data-invalid', 'true')
  } else {
    input.setAttribute('aria-invalid', 'true')
  }
}

function clearFieldError(input, form) {
  const slot = errorSlotFor(input, form)
  if (slot) {
    slot.textContent = ''
    slot.setAttribute('hidden', '')
  }
  if (input.type === 'radio') {
    const container = input.closest('[data-field-name]')
    container?.removeAttribute('data-invalid')
  } else {
    input.removeAttribute('aria-invalid')
  }
}

function validateField(input, form) {
  const message = errorMessageFor(input)
  if (message) {
    showFieldError(input, message, form)
    return false
  }
  clearFieldError(input, form)
  return true
}

document.querySelectorAll('form.hove-form').forEach(form => {
  form.addEventListener('submit', e => {
    let firstInvalid = null
    const seenGroups = new Set()

    form.querySelectorAll('input, textarea').forEach(input => {
      if (input.disabled) return
      if (input.type === 'hidden' || input.type === 'file') return

      // Radio's: groepeer op name, valideer maar één keer per groep
      if (input.type === 'radio') {
        if (seenGroups.has(input.name)) return
        seenGroups.add(input.name)
      }

      if (!validateField(input, form) && !firstInvalid) firstInvalid = input
    })

    if (firstInvalid) {
      e.preventDefault()
      const container = firstInvalid.closest('[data-field-name]') ||
                        firstInvalid.closest('fieldset, section') ||
                        firstInvalid.closest('div')
      container?.scrollIntoView({ behavior: 'smooth', block: 'center' })
      setTimeout(() => {
        if (firstInvalid.type !== 'radio') firstInvalid.focus({ preventScroll: true })
      }, 400)
    }
  })

  // Live validatie: zodra de gebruiker een veld verlaat, valideer het direct
  form.addEventListener('focusout', e => {
    const t = e.target
    if (!t.matches('input, textarea')) return
    if (t.type === 'radio' || t.type === 'hidden' || t.type === 'file') return
    validateField(t, form)
  })

  // Herveralideer een veld zodra de gebruiker iets typt of een keuze maakt
  form.addEventListener('input', e => {
    const t = e.target
    if (t.matches('input[aria-invalid="true"], textarea[aria-invalid="true"]')) {
      validateField(t, form)
    }
  })
  form.addEventListener('change', e => {
    const t = e.target
    if (t.type === 'radio') {
      const container = t.closest('[data-field-name]')
      if (container?.getAttribute('data-invalid') === 'true') {
        clearFieldError(t, form)
      }
    }
  })
})

// Live prijs-update op pakket-cards bij keuze van een ventilatie-apparaat
function formatEuro(amount) {
  if (Number.isInteger(amount)) {
    return `€ ${amount}`
  }
  return `€ ${amount.toFixed(2).replace('.', ',')}`
}

function cardPriceFor(card, { ventilation, device }) {
  const base = parseFloat(card.dataset.basePrice)
  const surcharge = parseFloat(card.dataset.extrasSurcharge || '0')
  const deviceSurch = parseFloat(card.dataset.deviceSurcharge || '0')
  return base + (ventilation ? surcharge : 0) + (device ? deviceSurch : 0)
}

function updatePackagePrices(form) {
  // 'Niets' bij ventilatie heeft value="" → falsy → geen toeslag.
  const extrasInput = form.querySelector('input[name="payload[extras]"]:checked')
  const ventilationSelected = !!(extrasInput && extrasInput.value)

  const deviceInput = form.querySelector('input[name="payload[device]"]:checked')
  const devicePremium = !!(deviceInput && deviceInput.value && deviceInput.value !== 'CV-ketel')

  const ctx = { ventilation: ventilationSelected, device: devicePremium }
  const contractDiscount = parseFloat(form.dataset.contractDiscount || '0')

  // De doorgestreepte prijs op contract-cards = huidige prijs van het Eenmalig-pakket.
  const eenmaligCard = form.querySelector('.hove-package[data-pkg-id="eenmalig"]')
  const singleVisitPrice = eenmaligCard ? cardPriceFor(eenmaligCard, ctx) : null

  form.querySelectorAll('.hove-package').forEach(card => {
    const newPrice = cardPriceFor(card, ctx)
    const priceEl = card.querySelector('.hove-pkg-price')
    if (priceEl && !Number.isNaN(newPrice)) {
      priceEl.textContent = formatEuro(newPrice)
    }

    // Eerste-beurt-prijzen voor contract-cards (Easy/Comfort)
    const fvOldEl = card.querySelector('.hove-pkg-fv-old')
    const fvNewEl = card.querySelector('.hove-pkg-fv-new')
    if (fvOldEl && fvNewEl && singleVisitPrice !== null) {
      fvOldEl.textContent = formatEuro(singleVisitPrice)
      fvNewEl.textContent = formatEuro(singleVisitPrice - contractDiscount)
    }
  })
}

document.querySelectorAll('form.hove-form').forEach(form => {
  if (!form.querySelector('.hove-package')) return

  form.addEventListener('change', e => {
    if (e.target.matches('input[name="payload[extras]"]') || e.target.matches('input[name="payload[device]"]')) {
      updatePackagePrices(form)
    }
  })

  updatePackagePrices(form)
})
